import {
  REQUEST_SHIPS,
  RECEIVE_SHIP_LIST,
  SHIP_LIST_ERROR,
  SET_SHIP_DETAILS
} from '../actions/ships'

const initialState = {
  isLoading: false,
  hasErrors: false,
  shipDetails: null
}

const ships = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SHIPS:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_SHIP_LIST:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: false
      })
    case SET_SHIP_DETAILS:
      return Object.assign({}, state, {
        shipDetails: action.payload
      })
    case SHIP_LIST_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: true
      })
    default:
      return state
  }
}

export const getShipImages = (state, numberOfImages) => {
  if (
    !state.ships.shipDetails ||
    !state.ships.shipDetails.image ||
    !state.ships.shipDetails.image.length
  ) {
    return []
  }
  if (state.ships.shipDetails.image.length < numberOfImages) {
    return state.ships.shipDetails.image
  }

  return state.ships.shipDetails.image.slice(0, numberOfImages)
}

export const getShipVideo = state =>
  state.ships.shipDetails && state.ships.shipDetails['featured_video']
    ? state.ships.shipDetails['featured_video']
    : null

export default ships
